// Copia as traduções que vieram no boot para onde o __() do Frappe as procura.
// Corre logo ao carregar o script, antes de o webshop desenhar seja o que for.
//
// Porquê isto existe: o Frappe não entrega traduções ao JavaScript das páginas
// públicas (só ao do backoffice). Ver cybershop/idioma/contexto.py.
(function () {
	if (typeof frappe === "undefined") return;
	frappe._messages = frappe._messages || {};
	if (frappe.boot && frappe.boot.__messages) {
		Object.assign(frappe._messages, frappe.boot.__messages);
	}
})();
